import { render, staticRenderFns } from "./inf.vue?vue&type=template&id=476763c7&"
import script from "./inf.vue?vue&type=script&lang=js&"
export * from "./inf.vue?vue&type=script&lang=js&"
import style0 from "./inf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports